import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { Header, McMenu, AssetSummary, AdvancedSettings } from '../components/';
import { Card, Spinner } from '@salesforce/design-system-react';

import * as Util from '../../common/utilities';
import { withFlags } from '../../flags/Flags';

import './SettingsRoot.scss';

export class SettingsRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }
  componentDidMount() {
    // TODO: can we bootstrap what we need with fewer API calls?
    this.props.actions.getAssetTypes();
    this.props.actions.getAssetAttributes();
    this.props.actions.getAssetSummary();
    this.props.actions.getAssetDistributionByKey('type');
    this.props.actions.getAttributes();
    this.props.actions.getRules();
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'assets.isLoadingAssetTypes',
        false
      )
    ) {
      if (this.props.assets.hasLoadedOnce) {
        if (!this.hasData() && !this.uploadSkipped()) {
          this.props.history.push('/welcome');
        } else {
          this.setState({ isLoading: false });
        }
      }
    }
  }

  hasData() {
    return this.props.assets.data.types.length;
  }

  uploadSkipped() {
    return localStorage.getItem('userSkippedUpload');
  }

  renderSpinner() {
    return (
      <div className="spinner-container">
        <Spinner variant="brand" />
      </div>
    );
  }

  renderSettings() {
    return withFlags(flags => {
      const assets = this.props.assets.data;
      const { summary } = assets;
      const chartRows = [
        {
          type: 'active',
          sum: summary.active
        },
        {
          type: 'expired',
          sum: summary.expired
        }
      ];
      return (
        <div className="dashboard-overview settings-root">
          {summary ? (
            <AssetSummary
              summary={summary}
              chartRows={chartRows}
              {...this.props}
              assets={assets}
              source="settings"
            />
          ) : null}
          <AdvancedSettings flags={flags} {...this.props} assets={assets} />
        </div>
      );
    });
  }

  render() {
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/settings"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <Card className="content-selection-root-card" hasNoHeader>
            {this.state.isLoading
              ? this.renderSpinner()
              : this.renderSettings()}
          </Card>
        </BrandBand>
      </McMenu>
    );
  }
}

SettingsRoot.contextTypes = {
  router: PropTypes.object
};

SettingsRoot.propTypes = {
  assets: PropTypes.object,
  attributes: PropTypes.object,
  actions: PropTypes.object,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  const { ecs, welcomeMat, ...others } = state;
  return {
    flags: state.ecs.flags,
    ...ecs,
    welcomeMat: welcomeMat.ecs,
    ...others
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SettingsRoot)
);
